<template>
    <div class="live-no-start">
        <div class="container" v-if="flag">
            <div class="hint">开播倒计时</div>
            <div class="count-down">{{ timeTextHint }}</div>
            <el-button class="start-button" @click="startLive" :disabled="!flag">
                <div class="mask" v-if="flag"></div>
                <div class="label">发起直播</div>
            </el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "LiveNoStartCenter",
    data() {
        return {};
    },
    props: {
        viewInfo: {
            type: Object,
            default: null,
        },
        flag: {
            type: Boolean,
            default: true,
        },
    },
    inject: ["toggleDebugDialog"],
    computed: {
        timeTextHint() {
            if (!this.viewInfo) return 0 + "秒";
            const liveTime = this.viewInfo.onlive.total_time.total_time;
            let hour = Math.floor(liveTime / 60 / 60);
            let minute = Math.floor(liveTime / 60) % 60;
            let second = liveTime % 60;
            const times = [hour, minute, second];
            const units = ["时", "分", "秒"];
            return times.reduce((str, item, index) => str + (item ? `${item}${units[index]}` : ""), "");
        },
    },
    components: {},
    methods: {
        startLive() {
            this.$emit("start-live");
        },
    },
    mounted() {},
};
</script>

<style scoped lang="scss">
.live-no-start {
    position: relative;
    flex: 1;
    display: flex;
    min-height: 0;

    .container {
        box-sizing: border-box;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 0;
        width: 100%;
        padding: 12px 16px 16px;

        .hint {
            width: 100%;
            text-align: center;
            font-size: 18px;
            color: #070932;
            font-weight: 700;
        }

        .count-down {
            width: 100%;
            margin: 24px 0 28px;
            text-align: center;
            font-size: 36px;
            font-weight: 700;
            color: #060111;
            line-height: 1.25;
        }

        .start-button {
            position: relative;
            flex-shrink: 0;
            align-self: center;
            width: 140px;
            height: 50px;
            color: #fff;
            font-size: 16px;
            background-color: #4b45ff;
            border-radius: 25px;
            overflow: hidden;
            z-index: 999;
            border: none;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0;

            .label {
                position: relative;
                z-index: 1;
                text-align: center;
            }

            .mask {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                pointer-events: none;
                transition: all 0.3s;
                background-color: transparent;
            }

            &:hover .mask {
                background-color: rgba(255, 255, 255, 0.1);
            }
        }
    }
}

/* Element 按钮内部 span 占满，保证文案相对按钮几何中心对齐 */
::v-deep .start-button > span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 0;
}
</style>
